// import 'ta-semantic-ui/semantic/dist/components/reset.css'
// import 'ta-semantic-ui/semantic/dist/components/site.css'
// import 'ta-semantic-ui/semantic/dist/components/header.css'
// import 'ta-semantic-ui/semantic/dist/components/segment.css'
// import 'ta-semantic-ui/semantic/dist/components/container.css'
// import 'ta-semantic-ui/semantic/dist/components/grid.css'
// import 'ta-semantic-ui/semantic/dist/components/divider.css'
// import 'ta-semantic-ui/semantic/dist/components/rail.css'
// import 'ta-semantic-ui/semantic/dist/components/button.css'
// import 'ta-semantic-ui/semantic/dist/components/message.css'
// import 'ta-semantic-ui/semantic/dist/components/table.css'
// import 'ta-semantic-ui/semantic/dist/components/icon.css'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'

import './App.scss'
import React from 'react'
import { Masthead } from '@ta-interaktiv/react-masthead'
// import CopyrightNotice from '@ta-interaktiv/react-copyright-notice'
// import ShareButtons from '@ta-interaktiv/react-polymorphic-share-buttons'
// import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import { Waypoint } from 'react-waypoint'
// import { Tracking } from '@ta-interaktiv/react-tracking'
import Cover from '../cover/'
import VideoAutoplay from '../videoAutoplay/'
import PanoEmbed from '../panoEmbed/'
import { Flipbook } from '../flipbook'
import InlineAudioPlayer from '../inlineAudioPlayer'
// import { parseHostname } from '@ta-interaktiv/js-toolbox'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
const ARTICLE_ID = '828665616954'
// region Images
const containerSizes =
  '(min-width: 1200px) 1127px, (min-width: 900px)' +
  '  calc(100vw - 2 * 25.5px), (min-width: 601px) calc(100vw - 2 * 17px), calc(100vw - 2 * 13px)'
const srcSet0445 = require('./img/PlaineMorte-0445.jpg?sizes=2254w+1127w+865w+574w')
const srcSet0480 = require('./img/PlaineMorte-0480.jpg?sizes=2254w+1127w+865w+574w')
const srcSet2325 = require('./img/PlaineMorte-2325.jpg?sizes=2254w+1127w+865w+574w')
const srcSet1941 = require('./img/PlaineMorte-1941.jpg?sizes=2254w+1127w+865w+574w')
const srcSet2357 = require('./img/PlaineMorte-2357.jpg?sizes=2254w+1127w+865w+574w')
const srcSetSizeComparisonVertical = require('./img/Vergleich_Plaine-Morte-ZRH_hoch.png?sizes=600w+300w')
const srcSetSizeComparisonHorizontal = require('./img/Vergleich_Plaine-Morte-ZRH_quer.png?sizes=1200w+800w')
// endregion

export class AppComponent extends React.Component {
  constructor(props) {
    super(props)

    this.fullscreenChange = this.fullscreenChange.bind(this)

    document.addEventListener('webkitfullscreenchange', this.fullscreenChange)
    document.addEventListener('mozfullscreenchange', this.fullscreenChange)
    document.addEventListener('fullscreenchange', this.fullscreenChange)
    document.addEventListener('MSFullscreenChange', this.fullscreenChange)
  }

  /**
   * Fullscreen change handler. This sets a global variable to true when a
   * pano is in fullscreen mode. This is used by the PanoEmbed component to
   * disable the unloading of iframes when entering the fullscreen mode.
   */
  fullscreenChange() {
    window.app.inFullscreen = !!(
      document.fullscreen ||
      document.webkitIsFullScreen ||
      document.mozFullScreen ||
      document.msFullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement
    )
  }

  render() {
    return (
      <div className='index' style={{ overflowX: 'hidden' }}>
        <Masthead
          inverted
          articleId={ARTICLE_ID}
          additionalFacebookShares={735}
        />
        <ThemeSwitch />
        <Cover
          title='In eisigen Tiefen'
          subtitle='Expedition in einen Gletscher'
        />

        <main className='ui vertical segment'>
          <div className='ui text container' style={{ position: 'relative' }}>
            <p
              className='ta lead'
              style={{
                fontSize: '133%'
              }}
            >
              Steigen Sie mit uns ab in die geheimnisvollen Eishöhlen des
              Plaine-Morte-Gletschers. 360-Grad-Panoramabilder, Videos und
              Animationen zeigen eine Welt, die sonst nur das Schmelzwasser
              kennt.
            </p>

            <p className='ta author'>
              Von Dominik Osswald, Urs Wyss, Christian Mülhauser und
              Interaktiv-Team
            </p>

            <aside className='ui vertical very fitted segment'>
              <aside className='ui info icon top attached message'>
                <i className='translate icon' />
                <div className='content'>
                  <div className='header'>Update 18. Mai 2017</div>
                  <p>
                    Aufgrund der vielen positiven Rückmeldungen haben wir uns
                    entschieden, eine&thinsp;
                    <a
                      href={`https://${
                        parseHostname().projectDomain
                      }/2017/into-the-deep/`}
                    >
                      englische Übersetzung des Artikels
                    </a>
                    &thinsp;anzubieten.
                  </p>
                </div>
              </aside>

              <aside className='ui info icon bottom attached message'>
                <i className='youtube play icon' />
                <div className='content'>
                  <div className='header'>360-Grad-Video</div>
                  <p>
                    In einem zusätzlichen Artikel finden Sie zudem ein
                    spektakuläres&thinsp;
                    <a
                      href={`//${
                        parseHostname().projectDomain
                      }/2017/eisige-tiefen-making-of/`}
                    >
                      360-Grad-Video aus den Tiefen des Gletschers
                    </a>
                    .
                  </p>
                </div>
              </aside>
            </aside>

            <Waypoint
              scrollableAncestor={window}
              onEnter={event => {
                if (event.previousPosition === 'below') {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: 'startReading'
                  })
                }
              }}
            />

            <aside className='ui vertical fitted segment large screen hidden widescreen hidden'>
              <img
                src={require('./img/swissmap.svg')}
                alt='Der Plaine-Morte-Gletscher auf der Schweizerkarte, zwischen Bern und Sion.'
                className='ui medium block centered image'
              />
            </aside>

            <p>
              Der Horizont ist selten eine gerade Linie in der Schweiz. Zu
              gebirgig ist das Land, und steht kein Berg im Weg, dann dafür ein
              Kamin oder ein Strommast. So überrascht der Blick nach Norden auf
              der eisigen Hochebene Plaine Morte, dem grössten Plateaugletscher
              der Alpen: Links das Gletscherhorn, rechts der Wildstrubel.
              Dazwischen eine scharfe Grenze zwischen Blau und Weiss, zwischen
              Himmel und Schnee, wie man es nur vom Nord- oder Südpol kennt.
            </p>

            <aside
              className='ui left rail computer or lower hidden'
              style={{ top: '45%' }}
            >
              <img
                src={require('./img/swissmap.svg')}
                alt='Der Plaine-Morte-Gletscher auf der Schweizerkarte, zwischen Bern und Sion.'
                className='ui fluid image'
              />
            </aside>

            <p>
              Das Eis liegt hier 200 Meter dick in einem gewaltigen Kessel hoch
              über den Tälern des Wallis und des Berner Oberlands auf rund 2700
              Metern über Meer. Der Name ist Programm: Es gibt hier kaum Leben,
              sondern meist nur die Weite und den Wind, der dem Schnee eine
              rauhe Oberfläche verpasst. Doch mit Ewigkeit hat das nichts zu
              tun. Bis Ende des Jahrhunderts wird der Gletscher weg sein. Im
              Jahr 2090 soll es gemäss Modellen von Glaziologen keinen Flecken
              Eis mehr geben. Bereits liegen Stahlseile und Masten an einem
              felsigen Hang – die Überreste eines Skilifts, dessen Betrieb wegen
              des Gletscherrückgangs eingestellt wurde.
            </p>
          </div>

          <PanoEmbed
            poster={require('./img/panoCover/wall.jpg')}
            url='//interaktiv.tagesanzeiger.ch/2016/plaine-morte/panos/wall/wall.html'
            caption='Das Ende der Schlucht: eine Eiswand, darunter ein Gewölbe. Ob das der Eingang ist?'
          />

          <div
            className='ui container mobile only'
            style={{ marginBottom: '1rem', marginTop: '-1rem' }}
          >
            <div className='ui teal small message '>
              <div className='header'>
                <i className='help circle icon' />
                360°-Panoramas
              </div>
              <div className='ui icon divided relaxed list'>
                <div className='item'>
                  <i className='maximize icon' />
                  <div className='content'>
                    Optimal sehen Sie die 360°-Panoramas im Vollbildmodus.
                  </div>
                </div>
                <div className='item'>
                  <i className='left arrow circle icon' />
                  <div className='content'>
                    Mit dem <em>Zurück-Button&nbsp;</em> Ihres Browsers gelangen
                    Sie zurück zum Artikel.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='ui text container'>
            <p>
              Das tote Eis birgt Geheimnisse. Niemand kennt sie so gut wie Fred
              Bétrisey und Hervé Krummenacher. Was sie berichten, ist schwer
              vorstellbar, wenn man die Weite betrachtet, die vor allem eines
              ist: monoton. Es soll hier eine Unterwelt verborgen sein, die so
              atemberaubend ist, dass man vergisst, sich zu fürchten, kaum dass
              man einen Fuss hineingesetzt hat und nur noch eines kennt: immer
              tiefer vordringen, als wollte man das Tageslicht nie mehr sehen.
              Dass Gletscher ein Innenleben haben, ist hinlänglich bekannt. Im
              Sommer sieht man das Schmelzwasser in tiefen Löchern im Eis
              verschwinden. Doch was dann kommt, weiss niemand so genau. Der
              Umstand, dass das Wasser unten aus dem Gletscher fliesst, bedeutet
              aber, dass zumindest zeitweise ein zusammenhängendes Kanalsystem
              besteht. Fred und Hervé wollen schaffen, was zuvor noch nie
              jemandem gelungen ist: dieses Labyrinth in seiner gesamten
              Dimension begehen. Es ist offenkundig, dass die beiden grossen
              Männer sich weit weniger schlank bewegen als ein Bächlein, doch
              sie lassen nichts unversucht, um dessen Wege zu erkunden. Wir
              begleiten sie.
            </p>
          </div>

          <div className='ui vertical segment'>
            {/* <VideoAutoplay
              mp4={require('./vid/trailer_d.mp4')}
              mp4Mobile={require('./vid/trailer_m.mp4')}
              webm={require('./vid/trailer_d.webm')}
              webmMobile={require('./vid/trailer_m.webm')}
              poster={require('./vid/trailer-poster.jpg')}
              silent={false}
            /> */}
          </div>

          <div className='ui text container'>
            <p>
              Zu Beginn dieses Winters ist es kalt und trocken – ideale
              Bedingungen, um in den Gletscher abzusteigen. Tatsächlich startet
              unsere Expedition vielversprechend, als wir kurz vor Weihnachten
              die Gletschermühle aufsuchen, die mitten in der Ebene liegt. Im
              Sommer stürzen hier die gesammelten Wassermassen in die Tiefe.
              Dann ist es ein Ort, an dem Banditen beruhigt eine Leiche für alle
              Ewigkeit verschwinden liessen. Doch im Winter versiegt das Wasser.
              Fred und Hervé stiegen hier schon rund 150 Meter ins Eis ab.
              «Zuerst geht es senkrecht hinunter, dann betritt man einen engen
              Gang, der seitlich wegführt …», erklärte Fred einige Tage zuvor in
              seinem Haus oberhalb von Sion. Er nahm ein Blatt Papier mit
              Rechenaufgaben seiner 11-jährigen Tochter zur Hand, drehte es um
              und fertigte in simplen Bleistiftstrichen eine Skizze des Lochs
              an, in das wir uns nun einer nach dem anderen abseilen.
            </p>
          </div>

          <aside className='ui vertical segment'>
            <figure className='ui container'>
              <img
                srcSet={srcSet0445.srcSet}
                src={srcSet0445.sources['865w']}
                sizes={containerSizes}
                alt=''
                className='ui fluid image'
              />
              <figcaption className='ta caption'>
                Im Sommer stürzen hier die Wassermassen herab. Im Winter wird
                das Loch für kurze Zeit begehbar.
              </figcaption>
            </figure>

            <figure className='ui container'>
              <img
                srcSet={srcSet0480.srcSet}
                src={srcSet0480.sources['865w']}
                sizes={containerSizes}
                alt=''
                className='ui fluid image'
              />
              <figcaption className='ta caption'>
                Der Eingang in die horizontalen Gänge ist winzig. Mit der
                Schaufel müssen wir nachhelfen – dann können wir passieren.
              </figcaption>
            </figure>
          </aside>

          <div className='ui text container'>
            <p>
              In rund fünfzig Meter Tiefe erreichen wir einen Schneeboden. Hervé
              erinnert daran, stets am Seil angebunden zu bleiben, denn
              möglicherweise ist das nur eine eingelagerte Etage im vertikalen
              Schlund und nicht tragfähig. «Das sieht hier jedes Jahr anders
              aus», sagt Fred, wobei er leicht besorgt zu einer mächtigen
              Schneebrücke über uns schaut. «Wenn die runterfällt, sind wir
              eingeschlossen. Aber es ist kalt, sie wirkt stabil.» Dann
              verschwindet er seitlich in eine Nische und beginnt zu schaufeln.
            </p>
            <p>
              «Bei etwas mehr Schnee hätten wir keine Chance», ruft Fred aus dem
              Dunkel. Es tönt gedämpft. Wir folgen ihm. Die Augen brauchen eine
              Weile, bis sie sich an die neue Umgebung gewöhnen. Es ist eine
              neue Welt: rundum blaues Eis, hart wie Beton und glänzend im Licht
              der Stirnlampen. Überall funkeln Schneekristalle. Der Boden ist
              flach wie eine Curlingbahn, das Eis knackt unter unseren
              Steigeisen,
              <InlineAudioPlayer
                audioTitle='So klingt es im Gletscher'
                source={require('./snd/sound-inside.aac')}
              >
                &nbsp;die Geräusche hallen wider{' '}
              </InlineAudioPlayer>
              . Aufrechtes Gehen ist bald unmöglich. Wir robben durch die Gänge.
              Es ist nicht besonders kalt. Nur beklemmend. Laut Fred sind wir
              rund 50 Meter unter der Oberfläche. Würde der Gletscher sich jetzt
              räuspern, wären wir zerquetscht.
            </p>

            <p>
              Eine seltsame Schneeschicht klemmt im Gang wie ein Brett. «Das ist
              ein Rest des Schnee-Wasser-Gemischs, das Anfang Winter hier noch
              fliesst», erklärt Hervé. In einer früheren Exkursion schwamm er
              mit Fred in Neoprenanzügen durch Gänge, die noch mit ebendieser
              Suppe gefüllt waren. Wir kriechen unter dem Relikt hindurch. Dann
              kann man wieder aufrecht gehen. Der Korridor ist hier mehrere
              Meter hoch und beschreibt eine 180-Grad-Kurve. Im Licht der
              Stirnlampen erkennen wir, dass das Eis hier zu einem Pfeiler
              geformt wurde.
            </p>
          </div>

          <PanoEmbed
            url='https://interaktiv.tagesanzeiger.ch/2016/plaine-morte/panos/gletschermuhle/muehle.html'
            poster={require('./img/panoCover/mill.jpg')}
            caption={
              'Plötzlich eine 180-Grad-Kurve. Auch die' +
              ' Glaziologen können nur mutmassen, was dem Richtungswechsel zugrunde liegt. '
            }
          />

          <div className='ui text container'>
            <p>
              Später erklärt der Glaziologe Matthias Huss, der an der ETH Zürich
              und an der Uni Fribourg lehrt, dass diese Form durch einen
              sogenannten Cut-and-Closure-Prozess entstanden sein könnte. Das
              Phänomen ist bisher vor allem bei Gletschern in der Arktis
              bekannt: Wenn Schmelzwasser in Bächen über den Gletscher fliesst,
              formt es tiefe Schluchten im Eis, die sich später an der
              Oberfläche wieder verschliessen. Im Untergrund aber bleiben sie
              bestehen. So könnte der ganze Gletscher von unterirdischen Canyons
              durchzogen sein, von denen man an der Oberfläche rein gar nichts
              merkt. Huss forscht seit Jahren auf dem Plaine-Morte-Gletscher.
              Drinnen war er noch nie. Er ist überrascht, als wir von
              horizontalen Gängen berichten. «Bisher sind wir davon ausgegangen,
              dass das Wasser durch die Gletschermühlen mehr oder weniger direkt
              senkrecht bis auf den Felsgrund fällt.» Er ist überzeugt, dass
              Beobachtungen aus dem Innern die Wissenschaft bereichern. «Nur so
              können wir prüfen, ob das bisherige Verständnis richtig war oder,
              ob man die ganze Theorie überdenken muss.»
            </p>
          </div>

          <aside className='ui container'>
            <figure className='ui vertical segment'>
              <VideoAutoplay
                mp4={require('./vid/Glacier_fertig_desktop.mp4')}
                mp4Mobile={require('./vid/Glacier_fertig_mobile.mp4')}
                webm={require('./vid/Glacier_fertig_desktop.webm')}
                webmMobile={require('./vid/Glacier_fertig_mobile.webm')}
                poster={require('./vid/glacier-poster.jpg')}
                silent
                showControls={false}
                allowAutoPlay
              />

              <figcaption className='ta caption'>
                Der Cut-and-Closure-Prozess, hier schematisch auf den Eisgang
                angewendet, könnte eine Erklärung sein, wie die Struktur
                entstanden ist. Bislang ist der Prozess aber vor allem bei
                arktischen Gletschern bekannt.
              </figcaption>
            </figure>
          </aside>

          <div className='ui text container' style={{ position: 'relative' }}>
            <aside className='ui right rail computer or lower hidden'>
              {/* <FeedbackMessage additionalClasses={[]} /> */}
            </aside>

            <p>
              In einen Gletscher hineingehen galt lange als Tabu – es schien
              schlicht zu gefährlich. Auch heute tun es nur wenige. Polnische
              Forscher machten in den 1990ern erste Beobachtungen. Sie begaben
              sich in Gletscher auf Spitzbergen, die ein überschaubares Risiko
              boten. Die klimatischen Verhältnisse sind im arktischen Winter
              ideal, die anhaltende Kälte dringt tief in den Gletscher ein und
              lässt alles erstarren. Der Winter der hiesigen Mittelbreiten ist
              dagegen deutlich weniger berechenbar: Temperaturschwankungen
              können auch in grosser Höhe jederzeit vorkommen und das plötzliche
              Auftreten von Schmelzwasser bedeuten. Das ist mit ein Grund,
              weshalb die Eishöhlenforschung selten im Alpenraum stattfand.
            </p>

            <p>
              Nach den Polen folgten weitere internationale Teams in arktischen
              Gletschern und im Himalaja. Doch so spektakulär ihre Beobachtungen
              auch waren, sie fanden kaum Resonanz in der Wissenschaft.
              Stattdessen wurde die Forschung in Eishöhlen als Abenteuer
              abgetan. Einer, der das nicht so sieht, ist der schottische
              Glaziologe Doug Benn. Er studierte jahrelang die Seen, die sich
              auf Gletschern im Himalaja bilden, und fragte sich, wieso sich
              diese immer wieder entleeren. Im Untergrund fand er Antworten.
              Benn erkannte, dass sich das Wasser genau gleich verhält wie im
              Fels: Es bahnt sich seinen Weg entlang der Schwachstellen. Während
              das im Fels aber Jahrmillionen dauert, geschieht es im Eis sehr
              viel schneller. Innerhalb eines Sommers kann sich ein
              Entwässerungskanal bilden – und im Winter kann er wieder
              verschlossen werden. Noch immer gibt es viele Fragezeichen,
              während Antworten immer wichtiger werden.
            </p>

            <p>
              Wenn die Gletscher in den nächsten Jahrzehnten sukzessive
              abschmelzen, werden immense Wasserreserven frei. Ganze Regionen
              können bedroht sein von ausbrechenden Gletscherseen und
              Flutwellen, die talwärts schiessen. Benn sagt: «In den Gletscher
              hineingehen ist wichtig, um die komplexen Prozesse zu verstehen
              und mit den oftmals vereinfachten Theorien des Wasserhaushalts
              aufzuräumen. Doch die meisten Glaziologen erachten es schlicht als
              zu verrückt. Dabei gab es eigentlich fast nur Unfälle, wenn sich
              Touristen im Gletschertor aufhielten, wo besonders im Sommer
              Eismassen herunterstürzen können.» Im Winter sei das Eis relativ
              stabil.
            </p>
          </div>

          <div className='ui container'>
            <figure className='ui vertical segment'>
              <img
                src={require('./img/PlaineMorte-0576.jpg')}
                alt=''
                className='ui block fluid image'
              />
              <figcaption className='ta caption'>
                In vertikalen Schächten geht es tief in den Gletscher.
                Irgendwann kommt der Felsgrund – doch so weit ist noch kein
                Mensch vorgedrungen.
              </figcaption>
            </figure>
          </div>
          <div className='ui text container'>
            <p>
              Am Boden entdecken wir eine Fliege, die im Eis festgefroren ist.
              Die Begegnung ist nicht nur eine Erinnerung daran, dass der
              Gletscher nicht mehr so bald hergibt, was er einmal hat, sondern
              auch ein Hinweis, dass der flache Boden durch das Einfrieren von
              stehendem Schmelzwasser entstand. Wir sind nun 70 Meter unter dem
              Eis. Je tiefer man kommt, desto angespannter fühlt man sich. Nicht
              auszudenken, wenn sich – aus welchem Grund auch immer – eine der
              engen Passagen hinter uns verschliesst. Dann erginge es uns wie
              der Fliege. Doch das Eis wirkt solid wie Mauerwerk. Es macht nicht
              den Anschein, als wollte es uns behalten. «Die grösste Gefahr ist
              ohnehin das Wasser», sagt Hervé, der zu ahnen scheint, dass wir
              nicht etwa wegen Müdigkeit immer stiller werden. «Es gibt auch im
              Winter Wasser hier unten. Dieses Jahr haben wir Glück: Es ist weit
              abgesunken, weil der Herbst so trocken war. Ein plötzlicher
              Anstieg wäre gefährlich.» Nichts deutet darauf hin. Es ist, als
              wäre alles stehen geblieben: das Wasser, das Eis ... die Zeit.
              Wüsste man es nicht besser, man würde sich in Ewigkeit wähnen.
            </p>

            <p>
              Hier beenden wir unseren ersten Vorstoss. Wir sind zwar noch lange
              nicht am tiefsten Punkt, es ginge noch über weitere Stufen bis
              rund hundertfünfzig Meter unter die Oberfläche. Ab dann wäre jeder
              weitere Schritt auch für Fred und Hervé Neuland – doch der weite
              Rückweg sollte uns für den Rest des Tages beschäftigen. Als wir
              wieder an die Oberfläche kommen, ist die Sonne längst hinter den
              Bergen verschwunden. Die Ebene leuchtet im schwachen Licht der
              Sterne.
            </p>
          </div>

          <PanoEmbed
            url='https://interaktiv.tagesanzeiger.ch/2016/plaine-morte/panos/camp/camp.html'
            poster={require('./img/panoCover/camp.jpg')}
            caption={
              'Nachts auf der Plaine Morte. Gemäss Modellen wird die weisse Ebene bis 2090 komplett weggeschmolzen sein.'
            }
          />

          <div className='ui text container' style={{ position: 'relative' }}>
            <p>
              Bei Pasta mit Thunfisch erläutern uns Fred und Hervé, was sie am
              Folgetag vorhaben: den Eingang am östlichen Ende des Gletschers
              finden – dort, wo eine Schlucht in den Gletscher eingetieft ist.
              «Es muss einen mächtigen Abgang geben», sagt Fred und erklärt,
              weshalb: Im Sommer befindet sich dort ein See aus Schmelzwasser,
              der Lac des Faverges. Dieser fliesst im Herbst abrupt ab, rund 2
              Millionen Kubikmeter Wasser verschwinden dann durch den Gletscher
              und tauchen erst weit unten wieder auf, wenn sie ins Simmental
              fliessen. «Es ist, als würde jemand den Stöpsel einer gigantischen
              Badewanne ziehen.» Die beschauliche Simme wird dann zum reissenden
              Strom, und die Gefahr einer zerstörerischen Flutwelle steigt jedes
              Jahr, denn der See wird immer grösser. In den letzten fünf Jahren
              hat sich sein Volumen verdreifacht. Und weil der Gletscher stark
              abgesunken ist, entwässert sich der See nicht mehr über den
              Bergkamm ins Wallis. Die Bäche sind dort ausgetrocknet.
              Stattdessen entlädt sich praktisch alles ins Berner Oberland. Seit
              2011 wird der Lac des Faverges überwacht, um die Bevölkerung zu
              warnen, wenn der Abfluss beginnt.
            </p>
          </div>

          <div className='ui container mobile hidden large screen hidden widescreen hidden '>
            <figure className='ui vertical segment'>
              <img
                srcSet={srcSetSizeComparisonHorizontal.srcSet}
                src={srcSetSizeComparisonHorizontal.sources['865w']}
                sizes={containerSizes}
                alt=''
                className='ui big centered image'
              />
            </figure>
          </div>

          <div className='ui text container' style={{ position: 'relative' }}>
            <div className='ui hidden divider computer or lower hidden' />

            <figure className='ui left rail computer or lower hidden'>
              <img
                srcSet={srcSetSizeComparisonVertical.srcSet}
                src={srcSetSizeComparisonVertical.sources['600w']}
                sizes='300px'
                alt=''
                className='ui fluid image'
              />
            </figure>

            <figure className='ui vertical segment mobile only'>
              <img
                srcSet={srcSetSizeComparisonVertical.srcSet}
                src={srcSetSizeComparisonVertical.sources['600w']}
                sizes='300px'
                alt=''
                className='ui medium centered image'
              />
            </figure>

            <Waypoint
              scrollableAncestor={window}
              onEnter={event => {
                if (event.previousPosition === 'below') {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: '50ContentRead'
                  })
                }
              }}
            />

            <p>
              Für Hervé und Fred ist klar, dass es mindestens zeitweise ein
              zusammenhängendes Höhlensystem durch den gesamten Gletscher geben
              muss – anders könnte sich der See nicht entleeren. Das
              unterirdische Kanalsystem erstreckt sich dann über rund 3,5
              Kilometer Distanz und überwindet 250 Höhenmeter. Diese gigantische
              Reise ist ihr grosser Traum. Doch ob das realistisch ist, darüber
              kann man nur spekulieren. «Man müsste mit dem Taucheranzug
              anrücken, wegen des Wasserspiegels», sagt Hervé. Will heissen: Ab
              einer bestimmten Tiefe wird es aussehen wie in der sinkenden
              Titanic – Gänge gefüllt mit Wasser. Wir rätseln und träumen noch
              eine Weile, ehe uns die Kälte in die Schlafsäcke treibt.
            </p>

            <p>
              Es ist minus 25 Grad. Einsam. Und totenstill. Kaum zu glauben,
              dass hier alles wegschmelzen wird in den kommenden Jahrzehnten.
            </p>

            <p>
              Der Plaine-Morte-Gletscher schwindet deutlich stärker als die
              anderen Alpengletscher. Dabei befand er sich zwischen 1960 und
              2002 noch fast im Gleichgewicht: Die Menge des im Winter
              entstehenden Eises entsprach ungefähr jener, die im Sommer
              abschmolz. Doch seit der Jahrtausendwende geschah ein rapider
              Wandel: Immer weniger Schnee überdauerte den Sommer. Eine
              Faustregel in der Glaziologie besagt, dass mindestens zwei Drittel
              der Eisoberfläche ganzjährig mit Schnee eingedeckt sein müssten,
              damit der Gletscher im Gleichgewicht bleibt. In den letzten vier
              Jahren war die Plaine Morte Ende Sommer jeweils komplett blank.
              Die Eismasse liegt hier aufgebahrt wie ein Toter fürs
              Himmelsbegräbnis, während die Geier im Gewand des Klimawandels
              aufziehen.
            </p>
          </div>

          <aside className='ui vertical segment'>
            <figure className='ui container'>
              <img
                srcSet={srcSet2357.srcSet}
                src={srcSet2357.sources['865w']}
                sizes={containerSizes}
                alt=''
                className='ui fluid image'
              />
              <figcaption className='ta caption'>
                Das Seebett ist trocken. Die Mulde geht in eine Schlucht über.
              </figcaption>
            </figure>
            <figure className='ui container'>
              <img
                srcSet={srcSet2325.srcSet}
                src={srcSet2325.sources['865w']}
                sizes={containerSizes}
                alt=''
                className='ui fluid image'
              />
              <figcaption className='ta caption'>
                Eine Eiswand markiert das Ende. Doch was verbirgt sich darunter?
              </figcaption>
            </figure>
          </aside>

          <div className='ui text container'>
            <p>
              Tags darauf betreten wir das leere Seebecken. Die anfänglich
              flache Mulde mündet in eine Schlucht, die sich tief ins Eis
              gefressen hat. Der Boden ist mit Schnee ausgekleidet, was das
              Gehen einerseits angenehm macht – andererseits wissen wir nicht,
              was unter uns ist. Also gehen wir angeseilt. Das Ende zeichnet
              sich ab: Eine mächtige Eiswand erhebt sich über einem Gewölbe, es
              sieht aus wie das Eingangsportal eines Tunnels. Das muss der
              Abfluss aus dem See sein. Hier donnern im Sommer Millionen Liter
              Wasser herab auf ihre Reise durch den Gletscher. Die Glaziologen
              vermuten, dass sich das unterirdische Abflusssystem jedes Jahr neu
              bildet. In den Wintermonaten werde es durch die Auflast des Eises
              zerdrückt, während es im Laufe des Sommers wieder aufschmilzt.
              Sobald das Kanalsystem einmal den See angezapft hat, geht es
              schnell: Die Kanäle weiten sich auf durch den Eintrag latenter
              Wärme vom Schmelzwasser und durch die Reibung. Die Abflussmenge
              nimmt deshalb in wenigen Stunden exponentiell zu.
            </p>
          </div>

          <aside className='ui container'>
            <figure className='ui vertical segment'>
              <VideoAutoplay
                mp4={require('./vid/see_d.mp4')}
                mp4Mobile={require('./vid/see_m.mp4')}
                webm={require('./vid/see_d.webm')}
                webmMobile={require('./vid/see_m.webm')}
                poster={require('./vid/see-poster.jpg')}
                silent
                showControls={false}
                allowAutoPlay
              />
              <figcaption className='ta caption'>
                Im Laufe des Sommers füllt sich der Lac des Faverges mit
                Schmelzwasser. Die Glaziologen vermuten, dass sich der
                Abflusskanal jedes Jahr neu bildet. Sobald ein Durchgang
                besteht, fliesst das Wasser rasch ab – bis zu 20 Kubikmeter pro
                Sekunde wurden gemessen.
              </figcaption>
            </figure>
          </aside>

          <div className='ui text container' style={{ position: 'relative' }}>
            <p>
              Wir erreichen die Eiswand. Und müssen enttäuscht feststellen, dass
              der Eingang verstopft ist mit Schnee. Keine noch so kleine Ritze
              ist da. Graben kann man vergessen. Von Luftbildern wissen wir,
              dass der Schluchtverlauf ähnlich aussieht wie ein Reissverschluss:
              Zunächst ist die Schlucht nach oben offen, wird dann aber zu einem
              feinen Strich in der Eisoberfläche, und schliesslich verschwindet
              sie ganz. Im Luftbild kann man drei Löcher in einer Reihe
              ausmachen, die den Verlauf anzuzeigen scheinen. Vielleicht
              Gletschermühlen, die ins unterirdische Kanalsystem münden? Wir
              steigen wieder hoch. Tatsächlich finden wir schon bald eines der
              Löcher. Aber ob dort der Schnee weniger ist? Wir seilen uns ab.
            </p>
          </div>

          <PanoEmbed
            url='https://interaktiv.tagesanzeiger.ch/2016/plaine-morte/panos/abyss/abyss.html'
            poster={require('./img/panoCover/abyss.jpg')}
            caption={
              'Ein kreisrundes Loch, wieder gefüllt mit' +
              ' Schnee. Doch diesmal ist es nicht verschlossen.'
            }
          />

          <div className='ui text container'>
            <p>
              Wiederum geht es senkrecht in die Tiefe. Und wieder ist da ein
              Schneeboden. Doch dann sehen wir, was unseren Puls höher schlagen
              lässt: Am tiefsten Punkt hängen Eiszapfen über einem dunklen Loch
              von vielleicht einem Meter Durchmesser.
            </p>
            <p>
              Dunkle Löcher sind gut. Je dunkler, desto besser – denn dann muss
              es weitergehen.
            </p>
            <p>
              Wir fixieren ein Seil. Geduckt geht es unter den Eiszapfen durch,
              ein erster Blick hinter den Vorhang&thinsp;… Unsere Laute der
              Begeisterung haben ein gewaltiges Echo. Nicht nur deswegen wissen
              wir um die Grösse des Raums, der sich uns gleich erschliessen
              wird. Auch im Licht unserer Stirnlampen zeichnet sich kein Ende
              ab.
            </p>
          </div>

          <PanoEmbed
            url='https://interaktiv.tagesanzeiger.ch/2016/plaine-morte/panos/bridge/bridge.html'
            poster={require('./img/panoCover/bridge.jpg')}
            caption={
              'Der Eingang ist schmal, dann tut sich ein Schacht auf. Es gibt ein Echo. '
            }
          />

          <div className='ui text container'>
            <p>
              Ein schmaler, jedoch hoher Schacht führt in die Dunkelheit. Zu
              unserem Erstaunen wird es nach einer Weile wieder heller,
              schwaches, bläuliches Licht kommt von oben. Weit über uns sehen
              wir einen runden Deckel, seitlich dringt Tageslicht ein. Wir
              können nur mutmassen – ob das eine Gletschermühle ist, die von
              oben verschlossen wurde? Sehen so die Schneeböden von unten aus,
              über die wir ständig gehen? Dass das Tageslicht rundum eindringt,
              macht keinen stabilen Eindruck. Wir reden fortan vom «Ufo-Deckel»
              (steht man unter einem landenden Ufo, soll es genau so aussehen,
              angeblich) und hoffen, dass er uns nicht auf den Kopf fällt.
            </p>
          </div>

          <aside className='ui vertical segment'>
            <figure className='ui container'>
              <img
                srcSet={srcSet1941.srcSet}
                src={srcSet1941.sources['865w']}
                sizes={containerSizes}
                alt=''
                className='ui fluid block image'
              />

              <figcaption className='ta caption'>
                Meter für Meter fixieren wir ein Seil entlang der Seitenwand.
                Denn der Boden trägt nicht mehr – wir haben das Wasser erreicht.
              </figcaption>
            </figure>
          </aside>

          <div className='ui text container'>
            <p>
              Zu unseren Füssen beschäftigt uns etwas anderes. Der Schacht
              endet, ein flacher Eisboden liegt vor uns. Doch nach nur zwei
              Schritten bricht er ein. Wir versinken, hechten zurück auf den
              tragenden Boden. Da ist es also, das Wasser, das ganzjährig im
              Gletscher flüssig bleibt und nicht gefriert. Die Alpengletscher
              sind «temperiert», ihre Temperatur im Inneren liegt bei etwa null
              Grad Celsius. Anders ist es bei arktischen, sogenannt kalten
              Gletschern, dort liegt die Temperatur unter null Grad. In den
              Alpen dringt die Winterkälte jedoch nur in die obersten rund 10
              Meter ein. Weiter unten können jederzeit Eis und Wasser
              nebeneinander vorkommen.
            </p>
          </div>

          <PanoEmbed
            url='https://interaktiv.tagesanzeiger.ch/2016/plaine-morte/panos/hatch/hatch.html'
            poster={require('./img/panoCover/hatch.jpg')}
            caption={
              'Von oben kommt Licht: der Ufo-Deckel. Zu' +
              ' unseren Füssen tut sich ein See auf. Der Weiterweg ist vom Wasser blockiert.'
            }
          />

          <div className='ui text container'>
            <p>
              Von jetzt an ist das Vordringen schwieriger: Wir fixieren Meter
              für Meter ein Seil an der Seitenwand und hangeln uns daran weiter.
              Hin und wieder klemmen grössere Eisschollen im Gang, deren
              Tragfähigkeit wir sorgfältig abtasten. Manchmal bieten sie einen
              willkommenen Boden.
            </p>
            <p>
              Wir erreichen einen Saal von der Grösse einer Kapelle. Ein kleiner
              See tut sich auf. Weit über uns leuchtet der Ufo-Deckel.
              Vermutlich sind wir die ersten Menschen, die diesen Raum betreten.
              An den Wänden hat es Fragmente von Eisplatten – hier muss sich der
              Wasserspiegel vor kurzem noch langsam gesenkt und die Platten an
              den Wänden zurückgelassen haben. Zum Teil sind sie so gross wie
              Tische und kleben unheilvoll über uns. Wir rätseln, ob unsere
              vereinte Körperwärme sie zum Absturz bringen könnte, und
              beschliessen, dass wir nicht mehr allzu lange hier verweilen
              sollten.
            </p>
            <figure className='ui container'>
              <Flipbook
                sizes={containerSizes}
                imageList={[
                  {
                    ...require('./img/PlaineMorte-0389.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Der Einstieg. Noch ist die Gletschermühle nicht mit Schnee verschlossen.'
                  },
                  {
                    ...require('./img/PlaineMorte-0430.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Nach 50 Metern Abseilen steht man auf einem Schneeboden. Nun gehts ins Dunkel.'
                  },
                  {
                    ...require('./img/PlaineMorte-0445.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Abseilen in der Gletschermühle. Im Sommer ergiesst sich hier ein Wasserfall in die Tiefe.'
                  },
                  {
                    ...require('./img/PlaineMorte-0456.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Weiter unten vermag der Schnee fast den Weiterweg zu verstopfen – wir müssen mit der Schaufel nachhelfen.'
                  },
                  {
                    ...require('./img/PlaineMorte-0509.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Durch ein kleines Loch erreichen wir schliesslich eine horizontale Galerie. Anfangs kann man noch aufrecht gehen.'
                  },
                  {
                    ...require('./img/PlaineMorte-0549.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Doch bald einmal kann man nur noch kriechen auf dem flachen Eisboden.'
                  },
                  {
                    ...require('./img/PlaineMorte-0497.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Es ist stockfinster, die Temperatur beträgt angenehme null Grad. Höhlenforscher Frédéric Bétrisey erkundet den Weiterweg. '
                  },
                  {
                    ...require('./img/PlaineMorte-0622.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'In den Gängen stecken oft Reste des Schnee-Wasser-Gemischs, das hier im Herbst noch fliesst. Wir kriechen unten durch. '
                  },
                  {
                    ...require('./img/PlaineMorte-2202.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Das Basecamp auf dem Gletscher. Hier ist es wesentlich kälter als unten in den Höhlen: Minus 25 Grad.'
                  },
                  {
                    ...require('./img/PlaineMorte-2266.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Strategieberatung im Küchen-Iglu: Werden wir den Abfluss aus dem See finden?'
                  },
                  {
                    ...require('./img/PlaineMorte-2325.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Die' +
                      ' Schlucht im Eis. Wir befinden uns hier im Auslauf des Seebeckens, wo das Wasser sich tief in den Gletscher gefressen hat. Am Ende vermuten wir den Abfluss – doch er ist verstopft mit Schnee. '
                  },
                  {
                    ...require('./img/PlaineMorte-2088.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Im weiteren Verlauf der Schlucht finden wir ein anderes Loch. Ob es hier weitergeht?'
                  },
                  {
                    ...require('./img/PlaineMorte-1880.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Tatsächlich – der Anfang Winter gefallene Schnee vermochte das Loch nicht vollständig zu verstopfen. '
                  },
                  {
                    ...require('./img/PlaineMorte-1928.jpg?sizes=2254w+1127w+865w+574w'),
                    caption: 'Ein dunkler Schacht führt in die Tiefe.'
                  },
                  {
                    ...require('./img/PlaineMorte-2023.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Plötzlich kommt Licht von oben. Wir vermuten, dass wir uns unter einer verschlossenen Gletschermühle befinden. '
                  },
                  {
                    ...require('./img/PlaineMorte-2062.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Wir haben das Wasser erreicht. Wir hangeln uns entlang dem Seil, Eisschollen schwimmen im Gang. '
                  },
                  {
                    ...require('./img/PlaineMorte-2056.jpg?sizes=2254w+1127w+865w+574w'),
                    caption:
                      'Über uns die schwache Lichtquelle. Stabil wirkt die Decke nicht. Hier ist Endstation. Die Gänge tauchen im Wasser ab. '
                  }
                ]}
              />
            </figure>
            <p>
              Am Ende des Raums sehen wir die Fortsetzung: Der Gang taucht ab –
              unter das Wasser. «Nächstes Mal müssen wir den Taucheranzug
              mitnehmen», sagt Hervé zu Fred. Die beiden meinen es ernst. Man
              spürt, dass sie hier unten zu Hause sind. Keine Widrigkeit soll
              sie von ihrem Traum abhalten. Doch für uns ist hier Endstation.
              Und wer weiss, wie es dort nächstes Jahr aussehen wird&thinsp;…
            </p>
          </div>

          <div className='ui  vertical segment'>
            <div className='ui text container'>
              <h4 className='teaser'>Lesen Sie auch den Folge-Artikel</h4>

              <div className='ui vertical very fitted segment'>
                <ArticleTeasers
                  articleIds={['18963942']}
                  additionalClasses='fluid stackable raised'
                  numberOfCards='two'
                />
              </div>
            </div>
          </div>
        </main>

        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'contentBottom'
              })
            }
          }}
        />
        <Footer
          articleId={ARTICLE_ID}
          hideUserFeedback
          credits={[
            ['Idee, Konzept und Text', 'Dominik Osswald'],
            [
              'Programmierung und Storytelling',
              'Kaspar Manz und Marc Brupbacher'
            ],
            [
              'Fotografie, 360°‑Panoramas, Drohnen-Aufnahmen, Videos',
              'Urs Wyss, Christian Mülhauser, avocado360, Olivier Christe, Dominik Osswald'
            ],
            [
              'Drohnen-Aufnahmen',
              'Urs Wyss, Christian Mülhauser, avocado360, Olivier Christe'
            ],
            ['Animationen', 'Pierre Tschopp, Ursula Ritter'],
            ['Illustrationen', 'Jürg Candrian'],
            [
              'Beratung 360°‑Bildproduktion',
              'Janina Woods, Sebastian Tobler, ateo GmbH'
            ],
            [
              'Dank an	',
              'Frédéric Bétrisey, Hervé Krummenacher, Matthias Huss, Glaziologe ETH und Uni Fribourg, Kathrin Naegeli, Uni Fribourg, Daniel Tobler, Geotest, Bergbahnen Crans-Montana, swisstopo'
            ]
          ]}
        />

        {/* <aside className='ui inverted teal vertical segment'>
          <div className='ui infographic container'>
            <table className='ui inverted definition infographic infographic top aligned very basic table'>
              <tbody>
                <tr>
                  <td>Idee, Konzept und Text</td>
                  <td>Dominik Osswald</td>
                </tr>

                <tr>
                  <td className='top aligned'>
                    Programmierung und Storytelling
                  </td>
                  <td>Kaspar Manz und Marc Brupbacher, Interaktiv-Team</td>
                </tr>

                <tr>
                  <td className='top aligned'>
                    Fotografie, 360°&#x2011;Panoramas
                  </td>
                  <td>
                    <div className='ui list'>
                      <div className='item'>
                        Urs Wyss, Christian Mülhauser
                        <br />{' '}
                        <a
                          style={{ color: 'lightblue' }}
                          href='http://www.avocado360.com'
                        >
                          avocado360
                        </a>
                      </div>
                      <div className='item'>Olivier Christe</div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>Drohnen-Aufnahmen</td>
                  <td>Christian Mülhauser</td>
                </tr>

                <tr>
                  <td className='top aligned'>Videos</td>
                  <td>
                    <div className='ui list'>
                      <div className='item'>Dominik Osswald</div>
                      <div className='item'>Christian Mülhauser</div>
                      <div className='item'>Olivier Christe</div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='top aligned'>Animationen</td>
                  <td>
                    <div className='ui list'>
                      <div className='item'>Pierre Tschopp</div>
                      <div className='item'>Ursula Ritter</div>
                      <div className='item'>
                        Die Firma&nbsp;
                        <a
                          href='https://www.geotest.ch/'
                          style={{ color: 'lightblue' }}
                        >
                          Geotest
                        </a>
                        &nbsp;überwacht den Lac des Faverges und lieferte Daten
                        für die 2. Animation
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>Illustrationen</td>
                  <td>Jürg Candrian</td>
                </tr>

                <tr>
                  <td className='top aligned'>
                    Beratung 360°&#x2011;Bildproduktion
                  </td>
                  <td>
                    Janina Woods, Sebastian Tobler <br />
                    <a style={{ color: 'lightblue' }} href='http://www.ateo.ch'>
                      ateo GmbH
                    </a>
                  </td>
                </tr>

                <tr>
                  <td className='top aligned'>Materialsponsoren</td>
                  <td>
                    <div className='ui list'>
                      <div className='item'>Haglöfs</div>
                      <div className='item'>Bächli Bergsport</div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='top aligned'>Dank an</td>
                  <td>
                    <div className='ui list'>
                      <div className='item'>Frédéric Bétrisey</div>
                      <div className='item'>Hervé Krummenacher</div>
                      <div className='item'>
                        Matthias Huss, Glaziologe ETH und Uni Fribourg
                      </div>
                      <div className='item'>Kathrin Naegeli, Uni Fribourg</div>
                      <div className='item'>Daniel Tobler, Geotest</div>
                      <div className='item'>Bergbahnen Crans-Montana</div>
                      <div className='item'>swisstopo</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <PanoEmbed
            url='https://interaktiv.tagesanzeiger.ch/2016/plaine-morte/panos/team/team.html'
            poster={require('./img/panoCover/team.jpg')}
            caption={'Das Team'}
          />
        </aside> */}

        {/* <div className='ui inverted teal vertical segment'>
          <div className='ui two column divided inverted grid container'>
            <div className='bottom aligned stackable mobile reversed row '>
              <div className='column mobile hidden'>
                <CopyrightNotice inverted /> 
              </div>
              <div className='column mobile only center aligned'>
                <CopyrightNotice inverted />
              </div>
              <div className='column'>
                <FeedbackMessage className='inverted' />
            <ShareButtons
                  className='basic inverted'
                  articleID='19579802'
                />{' '} 
                <Tracking articleId='19579802' /> 
                <Waypoint
                  scrollableAncestor={window}
                  onEnter={event => {
                    if (event.previousPosition === 'below') {
                      window.dataLayer = window.dataLayer || []
                      window.dataLayer.push({
                        event: 'pageBottom'
                      })
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div> */}
      </div>
    )
  }
}

AppComponent.defaultProps = {}

// /**
//  * @fileOverview The main entry point to your standalone. Start editing here.
//  */

// import React from 'react'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
// import './styles.scss'
// import { TypescriptComponent } from 'components/typescriptExample'
// import { Masthead } from '@ta-interaktiv/react-masthead'
// import { Footer } from '@ta-interaktiv/react-footer'
// import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// // TODO Set the correct article ID here
// const ARTICLE_ID = '00000000'

// export function AppComponent() {
//   return (
//     <div className='index'>
//       <Masthead articleId={ARTICLE_ID} />
//       <ThemeSwitch />

//       <header className='ui vertical  very fitted  segment'>
//         <div className='ui container'>
//           <div className='ui header'>
//             <h1>Lorem ipsum dolor sit amet, consectetuer adipiscing elit</h1>
//             <h2>
//               Nullam dictum felis eu pede mollis pretium. Integer tincidunt.
//               Cras dapibus. Vivamus elementum semper nisi. Donec quam felis,
//               ultricies nec, pellentesque eu, pretium quis, sem.
//             </h2>
//           </div>
//         </div>
//       </header>

//       <div className='ui vertical segment'>
//         <div className='ui text container'>
//           <div className='ta metainfo'>
//             <div className='ta author'>Hans Muster</div>
//             <div className='ta updated'>Aktualisiert am 31. XXXXXXX 2020</div>
//           </div>
//           <div className='ta text'>
//             Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque
//             penatibus et magnis dis parturient montes, nascetur ridiculus mus.
//             Nulla consequat massa quis enim. Donec pede justo, fringilla vel,
//             aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut,
//             imperdiet a, venenatis vitae, justo. Aenean vulputate eleifend
//             tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend
//             ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a,
//             tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque
//             rutrum.
//           </div>
//         </div>
//       </div>

//       <Footer articleId={ARTICLE_ID} credits={[['Credits', 'go here']]} />
//     </div>
//   )
// }
